export default __webpack_public_path__ + "static/media/aborted-icon.a9b21800.svg";